import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import views from './views';
import transitions from './transitions';
import { pageHeader } from '../components/PageHeader';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export default class BarbaApp {
	constructor() {
		this.targetHash = '';
		this.scrollPos = [];

		barba.hooks.once(({ current, next, trigger }) => {
			//
		});

		barba.hooks.before(({ current, next, trigger }) => {
			//
		});

		barba.hooks.beforeLeave(({ current, next, trigger }) => {
			pageHeader.hideBlur();
		});

		barba.hooks.leave(({ current, next, trigger }) => {
			//
		});

		barba.hooks.afterLeave(({ current, next, trigger }) => {
			const afterLeaveEvent = new CustomEvent('afterLeave', {
				bubbles: true,
				detail: {
					current,
					next,
					trigger,
				},
			});

			document.dispatchEvent(afterLeaveEvent);
		});

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			if (history.scrollRestoration) {
				history.scrollRestoration = 'manual';
			}

			const triggers = ScrollTrigger.getAll();
			triggers.forEach((trigger) => {
				trigger.kill();

				// Dit weer eens uitgecomment, kijken wat dit doet..
				// Aww merr gawd.. 1 volle labs dag verder.
				// Shame.. na een dag zoeken is dit de beste oplossing. Wellicht eens kijken of dit weg kan als er een nieuwe versie van gsap/scrollTrigger is
				// trigger.scroll.rec = null;
				// const lelijk = setInterval(() => {
				// 	if (trigger.scroll.rec !== null) {
				// 		trigger.scroll.rec = null;
				// 	}
				// }, 10);
			});

			this.replaceHeader(current, next);

			const blessEvent = new Event('bless', {
				bubbles: true,
			});

			next.container.dispatchEvent(blessEvent);
		});

		barba.hooks.enter(({ current, next, trigger }) => {
			if (trigger !== 'back') {
				this.scrollPos.push(barba.history.current.scroll.y);
			}
		});

		barba.hooks.afterEnter(({ current, next, trigger }) => {
			if (trigger !== 'back') {
				window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
			} else {
				window.scrollTo({ top: this.scrollPos.pop(), left: 0, behavior: 'instant' });
			}

			if (this.targetHash) {
				gsap.to(window, {
					duration: 2,
					scrollTo: { y: this.targetHash, offsetY: 200 },
					ease: 'power3.inOut',
				});

				history.replaceState(null, null, this.targetHash);
				this.targetHash = '';
			}
		});

		barba.hooks.after(({ current, next, trigger }) => {
			evalScripts(next);
			document.dispatchEvent(new Event('close-menu'));
			document.dispatchEvent(new Event('after-hook'));
		});

		barba.use(barbaPrefetch, {
			limit: 5,
		});

		//TODO: Check if I can make this more robust
		document.addEventListener('click', (e) => {
			const link = e.target.closest('a');

			if (link && link.href && link.origin === location.origin) {
				const url = new URL(link.href);

				// If navigating to another page, store the hash
				if (url.pathname !== location.pathname && url.hash) {
					this.targetHash = url.hash;
				}
				// If on the same page, handle scroll manually
				else if (url.hash && url.pathname === location.pathname) {
					e.preventDefault(); // Stop default jump behavior

					gsap.to(window, {
						duration: 2,
						scrollTo: { y: url.hash, offsetY: 200 },
						ease: 'power3.inOut',
					});

					// Update the URL manually
					history.replaceState(null, null, url.hash);
				}
			}
		});

		barba.init({
			debug: window.WPDATA.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				const url = new URL(href);

				if (!url) {
					return false;
				}

				// Prevent external links
				if (url.hostname !== window.location.hostname) {
					return true;
				}

				// Prevent if not a /-link
				if (!url.pathname.endsWith('/')) {
					return true;
				}

				return false;
			},
			views,
			transitions,
		});
	}

	replaceHeader(current, next) {
		const oldLang = document.documentElement.getAttribute('lang');
		if (!current.container) {
			return;
		}

		const html = next.html;
		const regex = /<header\b[^>]*>([\s\S]*?)<\/header>/gi;
		const headers = html.match(regex);

		const oldLogoEl = document.querySelector('[data-page-header-logo]');
		const oldMenuEl = document.querySelector('[data-page-header-menu-inner]');

		headers.forEach((header) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(header, 'text/html');
			const headerEl = doc.querySelector('header');
			const nextLang = headerEl.getAttribute('data-locale');

			const menuEl = doc.querySelector('[data-page-header-menu-inner]');
			oldMenuEl.replaceWith(menuEl);
			if (oldLang != nextLang) {
				const logoEl = doc.querySelector('[data-page-header-logo]');
				oldLogoEl.replaceWith(logoEl);
				// Update body lang attribute
				document.documentElement.setAttribute('lang', nextLang.replace(/_/g, '-'));
			}
			const updateHeaderEvent = new Event('update-header', {
				bubbles: true,
			});

			next.container.dispatchEvent(updateHeaderEvent);
		});
	}
}
